import { atom } from "recoil";

export type ThemeVariant = "dark" | "light";

const defaultTheme = (window.theme?.default || "light") as ThemeVariant;

const preferredTheme = localStorage.getItem(
  "themeVariant"
) as ThemeVariant | null;

const theme = preferredTheme ? preferredTheme : defaultTheme;

export const defaultSettingsState = {
  open: false,
  defaultCollapseContent: true,
  isSideBarOpen: true,
  isChatHistoryOpen: false,
  isTextEditorOpen: false,
  language: "en-US",
  theme,
};

export const settingsState = atom<{
  open: boolean;
  theme: ThemeVariant;
  isSideBarOpen: boolean;
  isChatHistoryOpen: boolean;
  isTextEditorOpen: boolean;
  language: string;
}>({
  key: "AppSettings",
  default: defaultSettingsState,
});
